import { render, staticRenderFns } from "./ArticleInfoEasyReadSocial.vue?vue&type=template&id=23ecd784&scoped=true"
import script from "./ArticleInfoEasyReadSocial.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoEasyReadSocial.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoEasyReadSocial.vue?vue&type=style&index=0&id=23ecd784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ecd784",
  null
  
)

export default component.exports